// @flow

import * as React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import copy from 'clipboard-copy';

import ButtonAction from './ButtonAction';

import type { CommonActionProps } from './types.actions';
import { DesktopView, MobileView } from '../../config/mediaQuery';

type Grid = {
  getClipString: () => mixed,
};

type Props = {
  grid: Grid,
  disabledDelay?: number,
  copy: any => typeof Promise,
};

type State = {
  status: string,
};

class CopyAction extends React.Component<Props & CommonActionProps, State> {
  static defaultProps = {
    size: 'xsmall',
    disabledDelay: 500,
    copy,
  };

  state = {
    status: '',
  };

  cp = (grid: Grid) => async () => {
    const text = grid.getClipString();

    this.setState({
      status: 'copying',
    });

    try {
      await this.props.copy(text);

      this.setState({
        status: 'copied',
      });
    } catch (e) {
      this.setState({
        status: 'failed',
      });
    }

    setTimeout(() => {
      this.setState({
        status: '',
      });
    }, this.props.disabledDelay);
  };

  render() {
    const disabled = this.state.status !== '' || this.props.disabled;

    return (
      <>
        <DesktopView>
          <ButtonAction
            onClick={this.cp(this.props.grid)}
            bsSize={this.props.size}
            disabled={disabled}
          >
            <Glyphicon glyph="duplicate" /> {this.state.status === '' && 'Copy'}
            {this.state.status === 'copied' && 'Copied'}
            {this.state.status === 'failed' && 'Failed'}
            {this.state.status === 'copying' && 'Copying...'}
          </ButtonAction>
        </DesktopView>
        <MobileView>
          <button onClick={this.cp(this.props.grid)} disabled={disabled} >
            <img src='assets/copy.svg' alt='copy icon'/> {this.state.status === '' && 'Copy'}
            {this.state.status === 'copied' && 'Copied'}
            {this.state.status === 'failed' && 'Failed'}
            {this.state.status === 'copying' && 'Copying...'}
          </button>
        </MobileView>
      </>
    );
  }
}

export default CopyAction;
